const SDK_VERSION = "11.0.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
